import * as NameSpace from '../NameSpace.js'
import { ParseService } from '../../Services/parse'
import { merge } from '../../Services/objectModifier'
import { pick } from 'lodash'

const state = {
  [NameSpace.PROFILE]: {
    profile: {
      manufacturer: '',
      name: '',
      phone: '',
      email: ''
    },
    error: null
  },
  [NameSpace.ALL_EMAILS]: {
    manufacturers: [],
    error: null
  },
  [NameSpace.EMAIL_SELECTED_BY_SUPERUSER]: null
}

const getters = {
  [NameSpace.GET_PROFILE]: state => {
    return state[NameSpace.PROFILE]
  },
  [NameSpace.GETTER_ALL_EMAILS]: state => {
    return state[NameSpace.ALL_EMAILS]
  },
  [NameSpace.GETTER_EMAIL_SELECTED_BY_SUPERUSER]: state => {
    return state[NameSpace.EMAIL_SELECTED_BY_SUPERUSER]
  }
}

const mutations = {
  [NameSpace.MUTATE_PROFILE]: (state, payload) => {
    let localUser = JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'))
    if (localUser && typeof (payload) === 'object') {
      let refUser = merge(localUser, JSON.parse(JSON.stringify(payload)))
      localStorage.setItem('Parse/74835-54897-3473865-437684/currentUser', JSON.stringify(refUser))
      state[NameSpace.PROFILE].profile = JSON.stringify(payload)
      // state[NameSpace.AUTH_STATE] = JSON.stringify(payload)
    }
  },
  [NameSpace.MUTATE_PROFILE_ERROR]: (state, payload) => {
    state[NameSpace.PROFILE].error = payload
  },
  [NameSpace.MUTATE_ALL_EMAILS]: (state, payload) => {
    state[NameSpace.ALL_EMAILS] = payload
  },
  [NameSpace.MUTATE_EMAIL_SELECTED_BY_SUPERUSER]: (state, payload) => {
    state[NameSpace.EMAIL_SELECTED_BY_SUPERUSER] = payload
  }
}

const actions = {
  [NameSpace.ACTION_PROFILE]: ({ commit }, payload) => {
    payload = pick(payload, ['email', 'phone', 'name'])
    ParseService.updateProfile(payload)
      .then(profile => {
        commit(NameSpace.MUTATE_PROFILE, payload)
      })
      .catch(error => {
        commit(NameSpace.MUTATE_PROFILE_ERROR, error)
        setTimeout(() => {
          commit(NameSpace.MUTATE_PROFILE_ERROR, null)
        }, null)
      })
  },
  [NameSpace.ACTION_ALL_EMAILS]: ({ commit }, payload) => {
    ParseService.getManufacturersForSuperUser(payload)
      .then(manufacturers => {
        commit(NameSpace.MUTATE_ALL_EMAILS, {manufacturers, error: null})
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_ALL_EMAILS, {manufacturers: [], error})
      })
  },
  [NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_EMAIL_SELECTED_BY_SUPERUSER, payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js